import { ToggleGroup, ToggleGroupItem } from "@win-reality/react-ui";
import { LayoutGroup } from "framer-motion";

import type { IGameState } from "../../../store/types";

type Props = {
  newGameState: IGameState;
  setNewGameState: React.Dispatch<React.SetStateAction<IGameState>>;
};

export const CountChanger = ({ newGameState, setNewGameState }: Props) => {
  const { count, outs } = newGameState;

  return (
    <div className="flex flex-col">
      {/* Balls */}
      <div className="flex flex-row items-center py-2.5">
        <div className="w-[35%] font-semibold text-lg">Balls</div>
        <LayoutGroup id="balls">
          <ToggleGroup
            type="single"
            value={String(count.balls)}
            onValueChange={(value) => {
              if (!value) return;
              setNewGameState({
                ...newGameState,
                count: { ...count, balls: Number(value) },
              });
            }}
          >
            {[0, 1, 2, 3].map((n) => (
              <ToggleGroupItem key={n} value={String(n)} className="text-sm">
                {n}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
        </LayoutGroup>
      </div>

      {/* Strikes */}
      <div className="flex flex-row items-center py-2.5">
        <div className="w-[35%] font-semibold text-lg">Strikes</div>
        <LayoutGroup id="strikes">
          <ToggleGroup
            type="single"
            value={String(count.strikes)}
            onValueChange={(value) => {
              if (!value) return;
              setNewGameState({
                ...newGameState,
                count: { ...count, strikes: Number(value) },
              });
            }}
          >
            {[0, 1, 2].map((n) => (
              <ToggleGroupItem key={n} value={String(n)} className="text-sm">
                {n}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
        </LayoutGroup>
      </div>

      {/* Outs */}
      <div className="flex flex-row items-center py-2.5">
        <div className="w-[35%] font-semibold text-lg">Outs</div>
        <LayoutGroup id="outs">
          <ToggleGroup
            type="single"
            value={String(outs)}
            onValueChange={(value) => {
              if (!value) return;
              setNewGameState({
                ...newGameState,
                outs: Number(value),
              });
            }}
          >
            {[0, 1, 2].map((n) => (
              <ToggleGroupItem key={n} value={String(n)} className="text-sm">
                {n}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
        </LayoutGroup>
      </div>
    </div>
  );
};
